import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { User } from './types';

const userSlice = (state: RootState) => state.user;

export const selectUser = createSelector([userSlice], (state): User => state);
